// extracted by mini-css-extract-plugin
module.exports = {"formDetails":"FormDetails_formDetails__NQLDq","variation":"FormDetails_variation__gW3ra","ingress":"FormDetails_ingress__gjrgV","formNumbers":"FormDetails_formNumbers__WSRbz"};